namespace Ir.Components.Workbook.WorkbookSideTabs {
    interface IViewModel {
        tabsConfig: DevExpress.ui.dxTabPanel.Properties;
    }

    let tabComponent: DevExpress.ui.dxTabPanel;
    let workbookListComponent: Ir.Components.Workbook.WorkbookList.IWorkbookListViewModel = null;
    let defaultTabVisibleIndex = 1;
    let selectedIndex = ko.observable(defaultTabVisibleIndex);
    export function getViewModel(this: IViewModel, params: any) {
        let config = params.config as WorkbookConfig;

        this.tabsConfig = {
            dataSource: getDataSource(this, config),
            width: "100%",
            height: "100%",
            animationEnabled: false,
            swipeEnabled: true,
            tabsPosition: "top",
            stylingMode: "secondary",
            iconPosition: "left" as any,
            repaintChangesOnly: true,
            itemTitleTemplate: titleTemplate,
            selectedIndex: selectedIndex as any,
            onInitialized(e) {
                tabComponent = e.component;
            },
            onSelectionChanged(e) {
                IntroService.refreshIntroHints();
            },
        };
    }

    function titleTemplate(itemData, itemIndex, itemElement) {
        let $icon = $('<i>').text(itemData.icon);

        if (itemData.iconClass) {
            $icon.addClass(itemData.iconClass);
        }
        else {
            $icon.addClass("ms");
        }

        itemElement.append($icon);

        itemElement.append($('<span>').text(' ' + itemData.title));

        if (itemData.templateClass) {
            itemElement.addClass(itemData.templateClass);
        }
    }

    function getDataSource(self: IViewModel, config: WorkbookConfig) {
        return [
            {
                icon: 'filter_alt',
                iconClass: 'ms',
                title: 'Drilldown Filters',
                template: () => {
                    let $div = $(`<drilldown-filters params="isToolbar: isToolbar"></drilldown-filters>`);
                    ko.applyBindings({ isToolbar: false }, $div.get(0));
                    return $div;
                },
                visible: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                    let visible = false;
                    if (this()) {
                        if (this().tabOrWidget == TabOrWidgetEnum.Widget || (this().tabOrWidget == TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() !== TabTypeEnum.Dashboard)) {
                            visible = this().drilldownManager.isDrilldown && isMobile();
                        }
                    }

                    if (!visible && selectedIndex() === 0) {
                        selectedIndex(defaultTabVisibleIndex);
                    }

                    return visible;
                }, workbook.workbookConfig.activeTabOrWidget)
            },
            {
                icon: 'filter_alt',
                title: 'Filters',
                templateClass: 'intro-filters-tab',
                template: () => {
                    let $div = $(`<filters params="config: $data.config, isToolbar: $data.isToolbar, element: $element"></filters>`);
                    ko.applyBindings({ config, isToolbar: false }, $div.get(0));
                    return $div;
                },
            },
            {
                icon: 'tune',
                title: 'Settings',
                templateClass: 'intro-settings-tab',
                template: () => {
                    let $div = $(`<tab-widget-settings params="config: $data"></tab-widget-settings>`);
                    ko.applyBindings(config, $div[0]);
                    return $div;
                },
                visible: ko.computed(function () {
                    let visible = workbook.workbookConfig.generalSettings.editing();
                    if (!visible && selectedIndex() === 2) {
                        selectedIndex(defaultTabVisibleIndex);
                    }

                    return visible;
                }),
            },
            {
                icon: 'import_contacts',
                title: 'Workbooks',
                template: function () {
                    let wlist = $(`<workbook-list params="getComponent: getComponent, getEmails: true"></workbook-list>`);
                    ko.applyBindings({
                        getComponent: (component: Ir.Components.Workbook.WorkbookList.IWorkbookListViewModel) => {
                            workbookListComponent = component;
                        }
                    }, wlist.get(0));

                    return wlist;
                }
            },
            
        ];
    }

    export function refresh() {
        tabComponent?.repaint();
    }

    export function updateWorkbookName(id: number, newName: string) {
        workbookListComponent?.refresh(id, newName);
    }

    export function goToDrilldownTab() {
        if (isMobile()) {
            let tab = workbook.workbookConfig.activeTabOrWidget();
            if (tab.tabOrWidget == TabOrWidgetEnum.Widget || (tab.tabOrWidget == TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() !== TabTypeEnum.Dashboard)) {

                if (tab.drilldownManager.isDrilldown) {
                    selectedIndex(0);
                }
            }
        }
    }
}